/*
  <cbg-product-recommendations> — "You May Also Like" (Swiper #2).

  On the product page this element is an empty shell. When it nears the viewport it fetches
  its own section via the recommendations URL (+ product_id), swaps in the rendered cards,
  then initializes a scoped Swiper (cbg-pdp-ymal__swiper). Uses the shared cbgLoadSwiper()
  loader from cbg-product.js if present; falls back to its own loader otherwise.
*/

(function () {
  function loadSwiper(jsUrl, cssUrl) {
    if (typeof window.cbgLoadSwiper === 'function') return window.cbgLoadSwiper(jsUrl, cssUrl);
    if (window.Swiper) return Promise.resolve();
    if (!window.__cbgSwiperPromise) {
      window.__cbgSwiperPromise = new Promise((resolve, reject) => {
        let pending = 2;
        const done = () => { pending -= 1; if (pending === 0) resolve(); };
        const fail = () => { window.__cbgSwiperPromise = null; reject(new Error('Swiper failed to load')); };
        const link = document.createElement('link');
        link.rel = 'stylesheet'; link.href = cssUrl; link.onload = done; link.onerror = fail;
        document.head.appendChild(link);
        const script = document.createElement('script');
        script.src = jsUrl; script.onload = done; script.onerror = fail;
        document.head.appendChild(script);
      });
    }
    return window.__cbgSwiperPromise;
  }

  if (customElements.get('cbg-product-recommendations')) return;

  class CbgProductRecommendations extends HTMLElement {
    connectedCallback() {
      /* If cards are already present (this is the fetched render), just init Swiper. */
      if (this.querySelector('.cbg-pdp-ymal__swiper')) {
        this.initSwiper();
        return;
      }
      if (!this.dataset.url || !this.dataset.productId) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            this.observer.disconnect();
            this.observer = null;
            this.loadRecommendations();
          }
        },
        { rootMargin: '400px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) { this.observer.disconnect(); this.observer = null; }
      if (this.swiper) { this.swiper.destroy(true, false); this.swiper = null; }
    }

    async loadRecommendations() {
      try {
        const url = `${this.dataset.url}&product_id=${this.dataset.productId}`;
        const response = await fetch(url);
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const fetched = html.querySelector('cbg-product-recommendations');
        if (!fetched || !fetched.querySelector('.cbg-pdp-ymal__swiper')) {
          this.remove(); /* no recommendations → remove the empty section */
          return;
        }
        this.innerHTML = fetched.innerHTML;
        await this.initSwiper();
      } catch (error) {
        console.warn('cbg-product-recommendations:', error);
      }
    }

    async initSwiper() {
      const swiperEl = this.querySelector('.cbg-pdp-ymal__swiper');
      if (!swiperEl) return;
      try {
        await loadSwiper(this.dataset.swiperJs, this.dataset.swiperCss);
      } catch (error) {
        console.warn('cbg-product-recommendations:', error.message);
        return; /* cards remain visible in the pre-init scroll fallback */
      }
      if (!this.isConnected || this.swiper) return;

      this.swiper = new window.Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        watchOverflow: true,
        navigation: {
          prevEl: this.querySelector('.cbg-pdp-ymal__arrow--prev'),
          nextEl: this.querySelector('.cbg-pdp-ymal__arrow--next'),
        },
      });
    }
  }

  customElements.define('cbg-product-recommendations', CbgProductRecommendations);
})();
